<template>
  <div class="attachment-detail">
    <template v-if="hasUrl">
      <FilePreview :value="url" />
    </template>

    <template v-else>
      <div v-if="isOrderDetail" class="custom-detail order-detail">
        <template v-if="orderDetailLoading">
          <span class="placeholder">加载订单信息…</span>
        </template>
        <template v-else>
          <el-button type="text" size="small" @click="goPassengerUserDetail()">用户详情</el-button>
          <el-button type="text" size="small"><span v-goRouteDetail="bizId">订单详情</span></el-button>
          <el-button type="text" size="small" @click="showRoutePlan()">行程规划</el-button>
          <el-button type="text" size="small" @click="go2QcPage()"><span>质检详情</span></el-button>
        </template>
      </div>

      <div v-else-if="isRouteDetail" class="custom-detail route-detail">
        <el-button type="text" size="small" @click="showRoutePlan()">行程规划</el-button>
        <el-button type="text" size="small" @click="showRouteList()">行程详情</el-button>
        <el-button type="text" size="small" @click="go2QcPage()"><span>质检详情</span></el-button>
      </div>

    </template>
  </div>
</template>

<script>
import FilePreview from "@/components/FilePreview";
import { SHOW_ROUTE_PLAN } from "@/core/const/global-event";
import Router from "@/route";
import { getOrderDetail } from "@/api/order";

export default {
  name: "AttachmentDetail",
  components: { FilePreview },
  props: {
    attachmentType: {
      type: [Number, String],
      default: null
    },
    bizId: {
      type: [Number, String],
      default: null
    },
    url: {
      type: String,
      default: ""
    },



  },
  computed: {
    hasUrl() {
      return this.url && typeof this.url === "string" && this.url.trim().length > 0;
    },
    isOrderDetail() {
      return this.typeConfig.orderTypes.includes(this.attachmentType);
    },
    isRouteDetail() {
      return this.typeConfig.routeTypes.includes(this.attachmentType);
    },
    /** 订单附件场景：bizId 为 orderId，行程相关操作需使用订单上的 routeId */
    resolvedRouteId() {
      if (this.isRouteDetail) {
        return this.bizId;
      }
      if (this.isOrderDetail && this.orderDetail) {
        return this.orderDetail.routeId;
      }
      return null;
    },
    /** 后端订单详情字段为 telephone，与列表等处 passengerTel 含义一致 */
    passengerTel() {
      if (!this.isOrderDetail || !this.orderDetail) {
        return "";
      }
      return this.orderDetail.telephone || this.orderDetail.passengerTel || "";
    }
  },
  data() {
    return {
      typeConfig: {
        orderTypes: ["ORDER"],
        routeTypes: ["ROUTE"],
      },
      orderDetail: null,
      orderDetailLoading: false
    };
  },

  watch: {
    bizId: {
      handler() {
        this.syncOrderDetail();
      },
      immediate: true
    },
    attachmentType() {
      this.syncOrderDetail();
    }
  },

  methods: {
    syncOrderDetail() {
      if (!this.isOrderDetail || !this.bizId) {
        this.orderDetail = null;
        this.orderDetailLoading = false;
        return;
      }
      this.orderDetailLoading = true;
      getOrderDetail(this.bizId, { _hideLoading: true })
        .then((res) => {
          this.orderDetail = res.data || null;
        })
        .finally(() => {
          this.orderDetailLoading = false;
        });
    },

    ensureRouteIdForOrderOps() {
      const rid = this.resolvedRouteId;
      if (rid == null || rid === "") {
        this.$message.warning("暂无关联行程，无法打开");
        return false;
      }
      return true;
    },

    goPassengerUserDetail() {
      const tel = (this.passengerTel || "").trim();
      if (!tel) {
        this.$message.warning("暂无乘客手机号，无法打开用户详情");
        return;
      }
      const { href } = Router.resolve({
        path: "/passenger/list",
        query: { tel }
      });
      window.open(href, "_blank");
    },

    showRoutePlan() {
      if (!this.ensureRouteIdForOrderOps()) {
        return;
      }
      this.$bus.$emit(SHOW_ROUTE_PLAN, { id: this.resolvedRouteId }, false);
      // this.$emit("close");
    },

    go2QcPage() {
      if (!this.ensureRouteIdForOrderOps()) {
        return;
      }
      const { href } = Router.resolve({
        path: "/route/qc",
        query: { routeId: this.resolvedRouteId }
      });
      window.open(href, "_blank");
    },

    showRouteList() {
      if (!this.ensureRouteIdForOrderOps()) {
        return;
      }
      const { href } = Router.resolve({
        path: "/route/list",
        query: { routeId: this.resolvedRouteId }
      });
      window.open(href, "_blank");
    }
  }
};
</script>

<style lang="less" scoped>
.attachment-detail {
  width: 100%;
  min-height: 40px;

  .custom-detail {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
  }

  .placeholder {
    color: #c0c4cc;
    font-size: 13px;
  }
}
</style>
